<ng-container *ngIf="mortgage$ | async as mortgage">
	<ui-section
		title="{{
			mortgage.priority ? (mortgage.priority | ordinalSuffix) + ' ' : ''
		}}Mortgage Details ({{ mortgage?.transactionType ?? '' | capitalize }})"
		[collapsable]="true"
	>
		<div section-content class="grid grid-cols-12 gap-4">
			<div class="col-span-4 flex flex-col gap-4">
				<ng-container
					*ngIf="
						(mortgage?.lenders | keyvalue)?.[0]?.value as mortgageLender;
						else noLender
					"
				>
					<div>
						<p class="p-sm">Lender</p>
						<h5 class="h5">{{ mortgageLender.name }}</h5>
					</div>
					<div class="mb-6">
						<img
							[src]="'/assets/images/banks/' + mortgageLender.logoUrl"
							class="h-16 w-auto"
						/>
					</div>
				</ng-container>
				<ng-template #noLender>
					<div>
						<p class="p-sm">Lender</p>
						<h5 class="h5">No Lender</h5>
					</div>
				</ng-template>
			</div>
			<div class="col-span-8">
				<div
					class="mb-4 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-2 gap-4 border-b pb-4"
				>
					<div class="space-y-2">
						<p class="p-sm">Principal Amount</p>
						<p class="p-sm font-medium text-gray-950">
							{{ mortgage?.amount | centsToDollars }}
						</p>
					</div>
					<div class="space-y-2">
						<p class="p-sm">Interest Rate</p>
						<p class="p-sm font-medium text-gray-950">
							{{ mortgage?.interestRateAsReg || mortgage?.interestRate }}
						</p>
					</div>
					<div class="space-y-2">
						<p class="p-sm">Closing Date</p>
						<p class="p-sm font-medium text-gray-950">
							{{ closingDate | date }}
						</p>
					</div>
					<div class="space-y-2">
						<p class="p-sm">Loan Reference #</p>
						<p class="p-sm font-medium text-gray-950">
							{{ mortgage?.referenceNumber }}
						</p>
					</div>
				</div>
				<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
					<div
						class="space-y-2"
						*ngIf="matterClients$ | async as matterClients"
					>
						<p class="p-sm">
							Borrower{{ matterClients.length > 1 ? 's' : '' }}
						</p>
						<p class="p-sm font-medium text-gray-950">
							<ng-container
								*ngFor="let client of matterClients; let last = last"
							>
								<span>{{ client | clientName }}{{ last ? '' : ', ' }}</span>
							</ng-container>
						</p>
					</div>
					<div class="mt-auto">
						<div class="flex flex-col gap-1">
							<ui-anchor (click)="goToDocuments()"
								>Go to mortgage instructions</ui-anchor
							>
							<ui-anchor (click)="reSyncInstructions()">
								Re-Sync Instructions
							</ui-anchor>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ui-section>
</ng-container>
